export default "__VITE_ASSET__DOvz4k_c__"